import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext.js";
import FullPageLoader from "../components/ui/fullPageLoader.js";

/**
 * ProtectedRoute
 * @param {ReactNode} children - الكومبوننت اللي عايز تحميه
 * @param {string[]} allowedRoles - أدوار المستخدمين المسموح لهم بالدخول
 */
export default function ProtectedRoute({ children, allowedRoles = [] }) {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <FullPageLoader />;

  if (!user) return <Navigate to="/auth/login" />; // لو مش logged in

  if (allowedRoles.length && !allowedRoles.includes(user?.role)) {
    // لو ال role مش مسموح له
    return <Navigate to="/unauthorized-page" />; // redirect للصفحة الرئيسية أو صفحة not authorized
  }

  return children;
}
